import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ErrorBoundary } from 'components/ErrorBoundary';
import { FleetMap } from 'components/FleetMap';
import { PageHeaderLayout } from 'components/PageHeaderLayout';
import { Collapse, Spinner } from 'components/ui';
import { DamageList } from 'horizon/routes/Inspections/DamageList';
import { useAccountContext } from 'utils/account/AccountContext';
import { SKYSPECS_ORG } from 'utils/constants';
import { useFeatures } from 'utils/features';

import { DamageList2 } from '../Inspections/DamageList2';

import UpcomingTasks from './UpcomingTasks';

const Section = styled.div`
  margin: 1em 0;
  &:first-child {
    margin-top: 0;
  }
`;

const StyledCollapsePanel = styled(Collapse.Panel)`
  div.ant-collapse-content-box {
    padding: 0;
  }
`;

const FleetMapHeader = styled.div`
  font-size: 1rem;
`;

export const Home = () => {
  const { t } = useTranslation();
  const { customer } = useAccountContext();
  const { features, loading: featuresLoading } = useFeatures();
  const { HORIZON_DAMAGES, LEGACY_DAMAGES } = features;

  return (
    <>
      <PageHeaderLayout title={t('navigation.dashboard', 'Dashboard')}>
        <Section data-testid="dashboard-damages">
          {featuresLoading ? (
            <Spinner />
          ) : HORIZON_DAMAGES ? (
            <DamageList2
              tableId="attention-required-damage-list-2"
              title={t('damage.attentionRequired', 'Attention Required')}
              critical={true}
              savedViews={false}
            />
          ) : LEGACY_DAMAGES ? (
            <DamageList
              tableId="attention-required-damage-list"
              title={t('damage.attentionRequired', 'Attention Required')}
              critical={true}
              pagination={5}
            />
          ) : null}
        </Section>
        <Section data-testid="dashboard-upcoming-tasks">
          <UpcomingTasks />
        </Section>
        {/* data-private used to hide images from LogRocket: https://docs.logrocket.com/reference/dom */}
        {/* temporarily hide the fleet map for skyspecs due to high tubine count breaking things */}
        {customer?.id !== SKYSPECS_ORG && (
          <Section data-testid="dashboard-fleet-map" data-private="logrocket-hide">
            <Collapse>
              <StyledCollapsePanel
                header={
                  <FleetMapHeader data-testid="dashboard-fleet-map-collapse">
                    {t('navigation.fleetMap', 'Fleet Map')}
                  </FleetMapHeader>
                }
                key={1}
              >
                <ErrorBoundary>
                  <div data-testid="dashboard-fleet-map-leaflet">
                    {featuresLoading ? <Spinner /> : <FleetMap />}
                  </div>
                </ErrorBoundary>
              </StyledCollapsePanel>
            </Collapse>
          </Section>
        )}
      </PageHeaderLayout>
    </>
  );
};
